import {
  applyBannerTextTemplate,
  DEFAULT_SIMPLE_BANNER_TEXT,
  splitBannerCarouselSlides,
  type BannerDisplayOptions,
} from './bannerDisplay';

export type BannerSlide =
  | { id: string; tone: 'pain' | 'brand' | 'offer' | 'simple'; text: string }
  | { id: string; tone: 'promo'; text: string; code: string };

/** Regular slide dwell; last offer slide gets LAST_SLIDE_MS so it is readable. */
export const SLIDE_MS = 4800;
export const LAST_SLIDE_MS = 6000;
export const ENTER_MS = 650;
export const LEAVE_MS = 550;

export function slideDurationMs(index: number, count: number): number {
  return index === count - 1 ? LAST_SLIDE_MS : SLIDE_MS;
}

/** Full pass through all texts: 5×4.8s + 6s = 30s for default carousel. */
export function cycleDurationMs(count: number): number {
  if (count <= 0) return SLIDE_MS;
  if (count === 1) return LAST_SLIDE_MS;
  return (count - 1) * SLIDE_MS + LAST_SLIDE_MS;
}

export function buildBannerSlides(
  code: string,
  bonusDays: number,
  opts: BannerDisplayOptions,
): BannerSlide[] {
  const custom = opts.text.trim();
  const vars = { code, days: bonusDays };

  if (opts.layout === 'simple') {
    return [
      {
        id: 'simple',
        tone: 'simple',
        text: applyBannerTextTemplate(custom || DEFAULT_SIMPLE_BANNER_TEXT, vars),
      },
    ];
  }

  if (custom) {
    const lines = splitBannerCarouselSlides(custom);
    const tones: Array<'pain' | 'brand' | 'promo' | 'offer'> = [
      'pain',
      'pain',
      'brand',
      'promo',
      'offer',
      'pain',
      'brand',
      'offer',
    ];
    return lines.map((line, i) => {
      const text = applyBannerTextTemplate(line, vars);
      const tone = tones[i % tones.length];
      if (tone === 'promo') {
        return { id: `custom-${i}`, tone: 'promo' as const, text, code };
      }
      return { id: `custom-${i}`, tone, text };
    });
  }

  return [
    {
      id: 'stream',
      tone: 'pain',
      text: 'Вечно зависает прямой эфир при просмотре?',
    },
    {
      id: 'bank',
      tone: 'pain',
      text: 'Постоянно приходится заходить и выключать ускорители, чтобы зайти в банк?',
    },
    {
      id: 'search',
      tone: 'pain',
      text: 'Каждый раз ищешь что работает и не можешь найти?',
    },
    {
      id: 'solve',
      tone: 'brand',
      text: 'Твой провайдер решит все эти проблемы',
    },
    {
      id: 'promo',
      tone: 'promo',
      text: 'Переходи по ссылке в описании и используй промокод',
      code,
    },
    {
      id: 'days',
      tone: 'offer',
      text: `Получай ${bonusDays} бесплатных дней и пользуйся стабильным интернетом каждый день`,
    },
  ];
}
